<template lang="pug">
    div

        div.pull-right
            ul.nav.pull-right
                li.nav-item.inline.dropdown
                    a(data-toggle="dropdown", class="nav-link btn btn-default") Export
                    div.dropdown-menu.dropdown-menu-scale.pull-right
                        span.dropdown-header Export As
                        a(class="dropdown-item", v-on:click.prevent="exportAsFile('CSV')") CSV
                        a(class="dropdown-item", v-on:click.prevent="exportAsFile('PDF')") PDF

            div.w-lg.m-r-sm.pull-right
                datepicker(
                    @onChange="applyDateFilter",
                    class-name="pull-right w-lg",
                    :auto-init-date="false",
                    :allow-empty="true",
                    :use-vuex="false"
                )

            div.w-md.m-r-sm.pull-right
                input(
                    type="search",
                    class="form-control",
                    placeholder="Search...",
                    @keyup="$refs.datatable.serverSearch($event)"
                )

        h5._300.margin.m-t-md Payment History
        
        div.box
            v-server-table(
                :url="api",
                :name="tableName" ref="datatable",
                :columns="columns",
                :options="options"
            )

        div(class="modal fade" id="receipt-modal" data-backdrop="false")
            div.right.w-xxl.white.b-l
                vuepopup_receipt(:transaction="transaction")
</template>

<script>
export default {
    data() {
        var vm = this;

        return {
            transaction: null,
            tableName: 'VUETABLE_COUPON_INVOICE',
            columns: [
                'coupon_id',
                'customer_name',
                'customer_email',
                'customer_phone',
                'quantity',
                'bill_id',
                'paid_at',
            ],
            options: {
                filterable: false,
                templates: {
                    bill_id(h_, row, index) {
                        return require('./bill_id.jsx')(h_, row);
                    },
                },
                rowClassCallback: row => 'pointer',
                headings: {
                    coupon_id: 'Coupon',
                    customer_name: 'Name',
                    customer_email: 'Email',
                    customer_phone: 'Phone',
                    quantity: 'Quantity',
                    bill_id: 'Bill',
                    paid_at: 'Paid Status',
                },
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.inventory.coupon.invoices');
        },

        tableParams() {
            let params = Object.assign(
                {},
                { query: this.$refs.datatable.query },
                this.$refs.datatable.customQueries,
            );

            return params;
        },
    },

    methods: {
        exportAsFile(type) {
            // let url = Laroute.route('franchise.report.customers.export_trans', {id: this.customerId, type: type});
            // window.location.href = url + '?' + $.param(this.tableParams);
        },

        applyDateFilter(payload) {
            let start = payload.start;
            let end = payload.end;

            this.$refs.datatable.customQueries.since = start;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'until',
                value: end,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/coupon/coupon-invoices.vue